import PropTypes from 'prop-types'
import styles from './Help.module.scss'

// The help text only uses numbered steps, bullets, tables, **bold** and plain paragraphs,
// so no Markdown library is needed. Text is rendered as React nodes, never as HTML.
const renderInline = (text) =>
  text
    .split(/(\*\*[^*]+\*\*)/g)
    .map((part, i) =>
      part.startsWith('**') && part.endsWith('**') ? (
        <strong key={i}>{part.slice(2, -2)}</strong>
      ) : (
        part
      ),
    )

const isTableLine = (line) => line.startsWith('|')
const isSeparatorLine = (line) => /^\|[\s:|-]+\|?$/.test(line)
const splitCells = (line) =>
  line
    .replace(/^\|/, '')
    .replace(/\|$/, '')
    .split('|')
    .map((cell) => cell.trim())

const parseBlocks = (text) => {
  const blocks = []
  let list = null
  let table = null
  ;(text || '').split('\n').forEach((raw) => {
    const line = raw.trim()
    if (isTableLine(line)) {
      list = null
      if (!table) {
        table = { type: 'table', head: splitCells(line), rows: [] }
        blocks.push(table)
      } else if (!isSeparatorLine(line)) {
        table.rows.push(splitCells(line))
      }
      return
    }
    table = null
    const step = line.match(/^\d+\.\s+(.*)$/)
    const bullet = line.match(/^[-*]\s+(.*)$/)
    if (step || bullet) {
      const type = step ? 'ol' : 'ul'
      if (!list || list.type !== type) {
        list = { type, items: [] }
        blocks.push(list)
      }
      list.items.push((step || bullet)[1])
    } else {
      list = null
      if (line) blocks.push({ type: 'p', text: line })
    }
  })
  return blocks
}

const HelpText = ({ text }) =>
  parseBlocks(text).map((block, i) => {
    if (block.type === 'p') return <p key={i}>{renderInline(block.text)}</p>
    if (block.type === 'table') {
      return (
        <div key={i} className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                {block.head.map((cell, j) => (
                  <th key={j}>{renderInline(cell)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, j) => (
                <tr key={j}>
                  {row.map((cell, k) => (
                    <td key={k}>{renderInline(cell)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    }
    const Tag = block.type
    return (
      <Tag key={i}>
        {block.items.map((item, j) => (
          <li key={j}>{renderInline(item)}</li>
        ))}
      </Tag>
    )
  })

HelpText.propTypes = { text: PropTypes.string }

export default HelpText
